/* eslint-disable */
const getters = {
  getCancelOrderReason(state) {
    return state.data;
  },
  getIsLoading(state) {
    return state.isLoading;
  },
};

export default getters;
